import { BAspect } from './aspect';
import { pluginFactory } from '../../utils/plugins';
var AspectPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAspect: BAspect
  }
});
export { AspectPlugin, BAspect };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/aspect/index.js
// module id = 89
// module chunks = 0